import React from 'react'

const Error = () => {
    return (
        <>
            Error page
        </>
    )
}

export default Error
